import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { ExaminationLayout } from 'src/layouts/examination';

import { LoadingScreen } from 'src/components/loading-screen';

const ExaminationDetailsPage = lazy(() => import('src/pages/examination/details'));
const ExaminationControlPage = lazy(() => import('src/pages/examination/control'));
const ExaminationStatisticsPage = lazy(() => import('src/pages/examination/statistics'));
const ExaminationUserStatisticsPage = lazy(() => import('src/pages/examination/user-statistics'));

export const examinationRoutes = [
  {
    path: 'examination',
    element: (
      <ExaminationLayout>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </ExaminationLayout>
    ),
    children: [
      {
        path: ':id',
        element: <ExaminationDetailsPage />,
      },
      {
        path: ':id/control',
        element: <ExaminationControlPage />,
      },
      {
        path: ':id/statistics',
        element: <ExaminationStatisticsPage />,
      },
      {
        path: ':id/user-statistics',
        element: <ExaminationUserStatisticsPage />,
      },
    ],
  },
];
